import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export default function Analytics() {
  const [stats, setStats] = useState({ scans: 0, leads: 0, rate: 0 })

  useEffect(() => { fetchStats() }, [])

  const fetchStats = async () => {
    const thirtyDaysAgo = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString()
    const { count: scans } = await supabase.from('sign_scans').select('*', { count: 'exact', head: true }).gte('scanned_at', thirtyDaysAgo)
    const { count: leads } = await supabase.from('leads').select('*', { count: 'exact', head: true }).gte('created_at', thirtyDaysAgo)
    setStats({ scans: scans || 0, leads: leads || 0, rate: scans ? Math.round((leads || 0) / scans * 100) : 0 })
  }

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Analytics</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-sm font-medium text-gray-500">Scans (30d)</p>
          <p className="text-3xl font-bold">{stats.scans}</p>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-sm font-medium text-gray-500">Leads (30d)</p>
          <p className="text-3xl font-bold">{stats.leads}</p>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-sm font-medium text-gray-500">Conversion</p>
          <p className="text-3xl font-bold">{stats.rate}%</p>
        </div>
      </div>
    </div>
  )
}
